import { render } from "./Receivers.vue?vue&type=template&id=7995b0fc&scoped=true"
import script from "./Receivers.vue?vue&type=script&lang=js"
export * from "./Receivers.vue?vue&type=script&lang=js"

import "./Receivers.vue?vue&type=style&index=0&id=7995b0fc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7995b0fc"]])

export default __exports__